import { buildApiUrl, createHeaders } from "./apiClient";

const parseOrThrow = async (res, fallback) => {
  if (!res.ok) {
    let msg = fallback;
    try {
      const payload = await res.json();
      if (payload?.error) msg = payload.error;
    } catch {
      /* ignore */
    }
    throw new Error(`${msg} (${res.status})`);
  }
  try {
    return await res.json();
  } catch {
    return { items: [], count: 0 };
  }
};

export const ACTIVITY_KINDS = [
  "event",
  "challenge",
  "document",
  "publication",
];

export const listActivity = async ({
  kinds,
  scope,
  teamKey,
  perSource,
  limit,
} = {}) => {
  const params = new URLSearchParams();
  if (Array.isArray(kinds) && kinds.length) {
    params.set("kinds", kinds.join(","));
  }
  if (scope) params.set("scope", scope);
  if (teamKey) params.set("team_key", teamKey);
  if (perSource) params.set("per_source", String(perSource));
  if (limit) params.set("limit", String(limit));

  const query = params.toString();
  const url = buildApiUrl(`/activity${query ? `?${query}` : ""}`);
  const res = await fetch(url, {
    method: "GET",
    headers: createHeaders(),
  });
  return parseOrThrow(res, "Failed to load activity");
};
